import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../sections/@dashboard/user';
import UserService from '../services/user_service'
import {Visible} from '../layouts/Visible'
import { useDispatch } from 'react-redux';

// ----------------------------------------------------------------------

const TABLE_HEAD = [

  { id: 'user_id', label: 'User Id', alignRight: false },
  { id: 'username', label: 'User Name', alignRight: false },
  { id: 'first_name', label: 'First Name', alignRight: false },
  { id: 'last_name', label: 'Last Name', alignRight: false },
  { id: 'source_name', label: 'Source', alignRight: false },
  { id: 'is_active', label: 'Is Active', alignRight: false },
  { id: 'is_blocked', label: 'Is Blocked', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Users() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const navigate = useNavigate();

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const dispatch = useDispatch();

    // useEffect(() => {
    //     dispatch({ type: 'ALL'} )
    // }, []);

  function loadUsers() {
    UserService.getUsersList(order, page, filterName)
      .then((response) => response.data)
      .then((data) => setData(data['data']))
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    loadUsers();
  }, [page]);



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    loadUsers();
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    // setSelected(newSelected);
    navigate("/users/" + name);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    loadUsers();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    loadUsers();
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    loadUsers();
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  // const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  // const isUserNotFound = filteredUsers.length === 0;

  return (
    <Visible roles={["admin"]}>
      <Page title="User">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Users
            </Typography>
          </Stack>

          <Card>
            <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} filterHint="Search User..." />

            <Scrollbar>
              <TableContainer cursor="pointer" sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={data.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody cursor="pointer">
                    {data.map((row) => {
                      // const { id, user_id, username, first_name } = row;
                      const { id, username, user_id, first_name, last_name, is_active, source_name, is_blocked } = row;
                      const avatar = `/static/mock-images/avatars/avatar_${1}.jpg`

                      return (
                        <TableRow
                          sx={{ cursor: 'pointer' }}
                          hover
                          key={id}
                          // tabIndex={-1}
                          onClick={(event) => handleClick(event, id)}
                        >

                          <TableCell component="th" scope="row" padding="normal">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar src={avatar} />
                              <Typography variant="subtitle2" noWrap>
                                {user_id}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{username}</TableCell>
                          <TableCell align="left">{first_name}</TableCell>
                          <TableCell align="left">{last_name}</TableCell>
                          <TableCell align="left">{source_name}</TableCell>
                          <TableCell align="left">{is_active ? 'Yes' : 'No'}</TableCell>
                          <TableCell align="left">{is_blocked ? 'Yes' : 'No'}</TableCell>

                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={-1}
              rowsPerPage={rowsPerPage}
              page={page}
              nextIconButtonProps={(data.length < rowsPerPage) ? { "disabled": true } : {}}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      </Page>
    </Visible>
  );
}
